import React, { useId } from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  isRTL?: boolean;
}
export function Input({
  label,
  error,
  isRTL = false,
  className = '',
  id,
  ...props
}: InputProps) {
  const inputId = id || useId();
  return <div className="w-full space-y-2" data-id="element-717">
      {label && <label htmlFor={inputId} className={`block text-sm font-medium text-gray-700 ${isRTL ? 'text-right' : 'text-left'}`} data-id="element-718">
          {label}
        </label>}
      <div className="relative" data-id="element-719">
        <input id={inputId} className={`
            block w-full rounded-lg border border-gray-300 px-4 py-3 text-gray-900 placeholder-gray-400
            focus:border-green-500 focus:outline-none focus:ring-2 focus:ring-green-500/20
            disabled:bg-gray-50 disabled:text-gray-500
            transition-all duration-200
            ${error ? 'border-red-500 focus:border-red-500 focus:ring-red-500/20' : ''}
            ${isRTL ? 'text-right' : 'text-left'}
            ${className}
          `} {...props} data-id="element-720" />
      </div>
      {error && <p className={`text-sm text-red-600 ${isRTL ? 'text-right' : 'text-left'}`} data-id="element-721">
          {error}
        </p>}
    </div>;
}